import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CommandProvider } from '@apigrowfinance/pbolt-command-search';
import ErrorBoundary from '@apigrowfinance/pbolt-error-boundary';
import IntlProvider from '@apigrowfinance/pbolt-intl-provider';
import QueryProvider from '@apigrowfinance/pbolt-query-provider';
import { ShortcutProvider } from '@apigrowfinance/pbolt-shortcut-provider';
import { ThemeProvider } from '@apigrowfinance/pbolt-theme-provider';

import Router from '@components/routing/Router';
import MUIThemeProvider from '@contexts/MUIThemeProvider';
import PermissionProvider from '@contexts/PermissionsProvider';
import RTLCacheProvider from '@contexts/RTLCacheProvider';

import ar from '../lang/compiled-lang/ar.json';
import en from '../lang/compiled-lang/en.json';
import pt from '../lang/compiled-lang/pt.json';

import DayjsLocale from './utils/dayjsLocale/DayjsLocale';

const App = ({ basename }: { basename: string }) => (
    <QueryProvider
        isDevelopment={process.env.NODE_ENV === 'development'}
        contextSharing>
        <PermissionProvider>
            <ThemeProvider>
                <MUIThemeProvider>
                    <RTLCacheProvider>
                        <CssBaseline />
                        <IntlProvider translationMessages={{ en, pt, ar }}>
                            <CommandProvider>
                                <DayjsLocale>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}>
                                        <ShortcutProvider>
                                            <ErrorBoundary>
                                                <Router basename={basename} />
                                            </ErrorBoundary>
                                        </ShortcutProvider>
                                    </LocalizationProvider>
                                </DayjsLocale>
                            </CommandProvider>
                        </IntlProvider>
                    </RTLCacheProvider>
                </MUIThemeProvider>
            </ThemeProvider>
        </PermissionProvider>
    </QueryProvider>
);

export default App;
